module.exports = "<mat-form-field>\n  <mat-select placeholder=\"Favorite food\">\n    <mat-option *ngFor=\"let food of foods\" [value]=\"food.value\">\n      {{food.viewValue}}\n    </mat-option>\n  </mat-select>\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/select-overview/select-overview.component.html
// module id = ./src/app/shared-components/select-overview/select-overview.component.html
// module chunks = main